import { __assign, __rest } from "tslib";
import React from 'react';
import VeltTranscriptionSummaryExpandToggleOffWireframe from './VeltTranscriptionSummaryExpandToggleOffWireframe/VeltTranscriptionSummaryExpandToggleOffWireframe';
import VeltTranscriptionSummaryExpandToggleOnWireframe from './VeltTranscriptionSummaryExpandToggleOnWireframe/VeltTranscriptionSummaryExpandToggleOnWireframe';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltTranscriptionSummaryExpandToggleWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-summary-expand-toggle-wireframe", __assign({}, transformedProps), children));
};
VeltTranscriptionSummaryExpandToggleWireframe.On = VeltTranscriptionSummaryExpandToggleOnWireframe;
VeltTranscriptionSummaryExpandToggleWireframe.Off = VeltTranscriptionSummaryExpandToggleOffWireframe;
export default VeltTranscriptionSummaryExpandToggleWireframe;
